export default {
	// common locales
    "delivery-platform.vendor-id": "Merchant ID",
    "delivery-platform.platform": "Platform",
    "delivery-platform.delivery-platform": "Delivery Platform",
    "delivery-platform.type": "Config Type",
    "delivery-platform.add-config": "New Integration",
    "delivery-platform.brand": "Brand",
    "delivery-platform.outlet": "Outlet",
    "delivery-platform.all-outlet": "All Outlets",
    "delivery-platform.terminal": "Terminal",
    "delivery-platform.all-terminals": "All Terminals",
    "delivery-platform.status": "Status",
    "delivery-platform.enable": "Enable",
    "delivery-platform.enabled": "Active",
	"delivery-platform.enabled-from-date": "Active from {date}",
    "delivery-platform.disable": "Disable",
    "delivery-platform.disabled": "Disabled",
    "delivery-platform.updated-by": "Updated By",
    "delivery-platform.last-menu-sync": "Last Menu Sync",
    "delivery-platform.config.menu-sync.processing": "Menu Syncing",
    "delivery-platform.config.menu-sync.failed": "Menu Syncing Failed",
    "delivery-platform.config.type.GRAB_MERCHANT_TO_UPOS_OUTLET": "Grab Merchant <--> uPOS Outlet",
    "delivery-platform.config.type.GRAB_MERCHANT_TO_UPOS_TERMINAL": "Grab Merchant <--> uPOS Terminal",
    
	// page titles
    "delivery-platform.config.page-description": "Expand your reach without the manual work. Sync your menus and consolidate all external orders from platforms like GrabFood and Foodpanda directly into your workflow.",
    "delivery-platform.order.page-description": "Audit your delivery pipeline. Check the validation status of all integrated orders to identify and resolve any sync issues between third-party platforms and your local terminals.",
    "delivery-platform.config.create-success-title": "Delivery Integration Connected.",
    "delivery-platform.config.create-success-description": "{brandName} - {outletName} - {terminalName} has been linked to {platform} Merchant ID {vendorId}.",
    
	// placeholders / tooltips
    "delivery-platform.config.search.placeholder": "Search for ID or Merchant ID",
    "delivery-platform.config.select-brand.placeholder": "Select a brand",
    "delivery-platform.config.select-outlet.placeholder": "Select an outlet",
    "delivery-platform.config.select-terminal.placeholder": "Select a terminal",
    "delivery-platform.config.select-platform.placeholder": "Select a delivery platform",
    
	// validation messages
    "delivery-platform.config.select-platform.required": "Which delivery platform to integrate with?",
    "delivery-platform.config.brand.required": "Which uPOS brand to integrate?",
    "delivery-platform.config.outlet.required": "Which uPOS outlet to integrate?",
    "delivery-platform.config.terminal.required": "Which uPOS terminal to integrate?",
    
    // misc
    "delivery-platform.config.grab-redirect": "Redirecting you to Grab's Merchant Portal. Pease do not close this tab.",
    "delivery-platform.config.disable.prompt": "Are you sure you want to disable Delivery Configuration for Config #{configId}?",
	"delivery-platform.config.enable.prompt": "Are you sure you want to enable Delivery Configuration for Config #{configId}?",
	"delivery-platform.config.re-enable.prompt": "When do you want to start integration from?",
	"delivery-platform.config.delete.prompt": "Are you sure you want to delete Delivery Configuration ID #{configId}?",
};
